import { observable, action, computed } from 'mobx';
import { IAppAndBUIDConfigs, IServiceAppConfig, IServiceAppConfigs } from './IConfig';

interface IAccountRoutes {
    signInPath: string;
    signOutPath: string;
}

export class Config {
    @observable public config: IServiceAppConfigs;

    constructor(appConfig: IServiceAppConfig) {
        this.updateConfig({ appConfig, buidConfig: {} });
    }

    @action
    public updateConfig(config: IAppAndBUIDConfigs) {
        this.config = {
            ...this.config,
            ...config?.appConfig,
            ...config?.buidConfig
        };
    }

    @computed
    public get languageId(): string {
        return this.config?.language?.id;
    }

    @computed
    public get accountRoutes(): IAccountRoutes {
        const { accountRoutes } = this.config?.accountConfig || {};
        const { signIn: signInPath = '/', signOut: signOutPath = '/' } = accountRoutes || {};

        return { signInPath, signOutPath };
    }
}
